import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { satrang25TicketLinks } from "../../../seeds/satrang.page";
const Event1 = (props) => {
  const { openNewTab = () => {} } = props;
  return (
    <Card>
      <CardMedia
        sx={{ height: [400, 700], backgroundSize: "contain" }}
        image={
          "https://res.cloudinary.com/dvkw3ivfp/image/upload/v1756869106/sichen-vertical_wfzfhd.png"
        }
        title="Siachen"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          Siachen
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Siachen, a touching and thought-provoking play by Aditya Rawal, is set
          against the harsh backdrop of the Siachen Glacier, known as the
          highest and one of the most dangerous battlefields in the world. The
          story explores the emotional, physical, and mental challenges faced by
          soldiers on both sides of the Indo-Pakistan conflict. Through
          well-developed characters, Siachen shows the soldiers'
          vulnerabilities, fears, and strength. It highlights the bonds they
          form with each other, the support they give one another, and their
          efforts to stay mentally strong in an environment that tests their
          will.
        </Typography>
        <Typography variant="h6" sx={{ mt: 1 }}>
          Team:
        </Typography>
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            Writer:{" "}
            <Link
              to="https://www.imdb.com/name/nm9031403/"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Aditya Rawal <OpenInNewIcon sx={{ fontSize: "0.8em" }} />
            </Link>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Director:{" "}
            <Link
              to="https://www.imdb.com/name/nm14351193/"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Vivek Sharma <OpenInNewIcon sx={{ fontSize: "0.8em" }} />
            </Link>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Assistant director: Sabina Singh
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Translation: Raghav Dutt
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Art director: Karan Sheth
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Graphics: Rohit Rawat
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Actors: Vivek Sharma, Ganesh Gujar, Aman Thakur, Manmeet Narang,
            Rohit Guleria
          </Typography>
        </Stack>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() => {
            openNewTab(satrang25TicketLinks);
          }}
        >
          Get tickets
        </Button>
      </CardActions>
    </Card>
  );
};

export default Event1;
